import React, { useState, useEffect } from 'react';
import { Link, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './Dashboard.css';
import { useAuth } from '../../context/AuthContext';
import { perfilApi } from '../../api';
import { isPerfilCompleto } from './components/Perfil/Perfil';
import Perfil from './components/Perfil/Perfil';
import MisSolicitudes from './components/MisSolicitudes/MisSolicitudes';
import MisCreditos from './components/MisCreditos/MisCreditos';
import NuevaSolicitud from './components/NuevaSolicitud/NuevaSolicitud';
import InfoCredito from './components/InfoCredito/InfoCredito';

const navItems = [
  { to: '',              icon: 'fa-solid fa-chart-line',    label: 'Mis Solicitudes', section: 'solicitudes' },
  { to: 'nueva-solicitud', icon: 'fa-solid fa-file-pen',      label: 'Nueva Solicitud', section: 'nueva' },
  { to: 'mis-creditos',   icon: 'fa-solid fa-credit-card',   label: 'Mis Créditos',    section: 'creditos' },
  // { to: 'info-credito', label: 'Info del Crédito' }, // oculto
  { to: 'perfil',        icon: 'fa-solid fa-user-gear',     label: 'Mi Perfil',        section: 'perfil' },
];

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sideOpen, setSideOpen] = useState(false);
  const [perfilIncompleto, setPerfilIncompleto] = useState(false);

  useEffect(() => {
    perfilApi.getPerfil()
      .then((data) => {
        if (!isPerfilCompleto(data.persona)) {
          setPerfilIncompleto(true);
        }
      })
      .catch(() => { /* silently ignore */ });
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (to) => {
    const base = '/dashboard';
    const full = to ? `${base}/${to}` : base;
    return location.pathname === full || (to === '' && location.pathname === base);
  };

  const initials = user
    ? `${user.nombre?.[0] ?? ''}${user.apellido?.[0] ?? ''}`.toUpperCase()
    : '?';

  return (
    <div className="dashboard">
      {/* ── Sidebar ────────────────────────────────────── */}
      <aside className={`dash-sidebar${sideOpen ? ' dash-sidebar--open' : ''}`}>
        <div className="dash-sidebar__header">
          <Link to="/" className="dash-sidebar__logo">
            <img src={process.env.PUBLIC_URL + '/cash_logo_color-06.png'} alt="Cash Sol SAC" />
          </Link>
          <button className="dash-sidebar__close" onClick={() => setSideOpen(false)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="dash-sidebar__user">
          <div className="dash-sidebar__avatar">{initials}</div>
          <div>
            <strong>{user?.nombre} {user?.apellido}</strong>
            <span>DNI {user?.numero_documento}</span>
          </div>
        </div>

        <nav className="dash-sidebar__nav">
          <div className="dash-nav-label">Menú</div>
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to ? `/dashboard/${item.to}` : '/dashboard'}
              className={`dash-nav-item${isActive(item.to) ? ' dash-nav-item--active' : ''}`}
              data-section={item.section}
              onClick={() => setSideOpen(false)}
            >
              <span className="dash-nav-item__icon">
                <i className={item.icon}></i>
              </span>
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="dash-sidebar__footer">
          <Link to="/" className="dash-nav-item" data-section="home">
            <span className="dash-nav-item__icon"><i className="fa-solid fa-house"></i></span>
            <span>Ir al inicio</span>
          </Link>
          <button className="dash-nav-item dash-logout" onClick={handleLogout}>
            <span className="dash-nav-item__icon"><i className="fa-solid fa-right-from-bracket"></i></span>
            <span>Cerrar sesión</span>
          </button>
        </div>
      </aside>

      {/* Overlay mobile */}
      {sideOpen && <div className="dash-overlay" onClick={() => setSideOpen(false)}></div>}

      {/* ── Main ───────────────────────────────────────── */}
      <main className="dash-main">
        <header className="dash-topbar">
          <button className="dash-topbar__toggle" onClick={() => setSideOpen(true)}>
            <i className="fa-solid fa-bars"></i>
          </button>
          <h1 className="dash-topbar__title">Portal del Cliente</h1>
          <div className="dash-topbar__user">
            <i className="fa-solid fa-user" style={{ width: 28, height: 28,
              background: 'linear-gradient(135deg,#f0c040,#f7a600)',
              borderRadius: '50%', display:'flex', alignItems:'center',
              justifyContent:'center', color:'#0e2a56', fontSize:'0.8rem' }}></i>
            <span>{user?.nombre}</span>
          </div>
        </header>

        <div className="dash-content">
          {perfilIncompleto && !location.pathname.includes('perfil') && (
            <div className="dash-notif dash-notif--warning">
              <i className="fa-solid fa-triangle-exclamation"></i>
              <span>Tienes datos personales pendientes por completar.</span>
              <Link to="/dashboard/perfil" className="dash-notif__link">
                Completar perfil <i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>
          )}
          <Routes>
            <Route index element={<MisSolicitudes />} />
            <Route path="nueva-solicitud" element={<NuevaSolicitud />} />
            <Route path="mis-creditos" element={<MisCreditos />} />
            <Route path="info-credito" element={<InfoCredito />} />
            <Route path="perfil" element={<Perfil />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
